module.exports = __webpack_public_path__ + "static/media/car-cemetery-coffin-svgrepo-com.1cc89eb4.svg";